<template>
  <div class="page__counter">
    <input
      v-if="item[modelField] > min"
      class="form-control counter__button"
      type="button"
      value="-"
      @click="minus"
    />
    <input
      class="counter__input"
      v-model="item[modelField]"
      @keypress="isNumber($event)"
      @change="checkValue($event)"
    />
    <input
      type="button"
      class="form-control counter__button"
      value="+"
      @click="plus"
    />
  </div>
</template>

<script>
import { useInputValidator } from '@/_shared/mixins';
export default {
  mixins: [useInputValidator],
  emits: ['change'],
  props: {
    min: {
      type: Number,
      default: 0,
    },
    modelField: {
      type: String,
      default: 'count',
    },
    item: {
      type: Object | String,
      default: null,
    },
  },
  methods: {
    plus() {
      this.$emit('change');
      this.item[this.modelField]++;
    },
    minus() {
      this.$emit('change');
      this.item[this.modelField]--;
    },
    checkValue(event) {
      if (event.target.value < 1) {
        this.item[this.modelField] = this.min;
      }
      this.$emit('change');
    },
  },
};
</script>

<style scoped>
.page__counter {
  display: inline-flex;
  justify-content: center;
}
.page__counter .counter__input {
  width: 2em;
  margin: 0 0.5em;
  text-align: center;
}
.page__counter .counter__input:focus {
  outline: none;
}
.counter__button {
  padding: 0;
}
.page__counter > input {
  box-shadow: none;
  background: transparent;
  font-style: normal;
  border: none;
  font-size: 18px;
  color: #313541;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Counter.vue